import { render, staticRenderFns } from "./EditCertificationModal.vue?vue&type=template&id=a7f974a2&"
import script from "./EditCertificationModal.vue?vue&type=script&lang=js&"
export * from "./EditCertificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports